import { WalletType } from '../../../shared/enums/wallet-type.enum';

export class WalletUpdateDto {
	benefitId: string | null;
	id: string;
	isHealth: boolean;
	isNotApplicable?: boolean;
	isTeeth: boolean;
	type: WalletType;
	updatedInInsuranceAt: string | null;
	walletNumber: string | null;

	constructor({
		id,
		benefitId,
		isHealth,
		isNotApplicable,
		isTeeth,
		type,
		updatedInInsuranceAt,
		walletNumber,
	}: WalletUpdateDto) {
		this.benefitId = benefitId;
		this.id = id;
		this.isHealth = isHealth;
		this.isNotApplicable = isNotApplicable;
		this.isTeeth = isTeeth;
		this.updatedInInsuranceAt = updatedInInsuranceAt;
		this.walletNumber = walletNumber;
		this.type = type;
	}
}
